import styled from 'styled-components';
import { Icon } from 'antd';
import { spaceX } from 'components/styles';

export const ToastBody = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0.5rem 1rem;
	width: 30rem;
	position: relative;
`;

export const ToastTitle = styled.h1`
	color: ${({ theme }) => theme.red};
	font-weight: ${({ theme }) => theme.font.distinct};
	font-size: 2rem;
	margin-bottom: 0.5rem;
`;

export const ToastSubTitle = styled.h2`
	font-weight: ${({ theme }) => theme.font.normal};
	color: ${({ theme }) => theme.silver};
	font-style: italic;
	font-size: 1.2rem;
	margin-bottom: 1rem;
`;

export const ToastErrorList = styled.ul`
	color: ${({ theme }) => theme.silver};
	font-size: 1.2rem;
`;

export const StyledIcon = styled(Icon)`
	color: ${({ theme }) => theme.red};
	font-weight: ${({ theme }) => theme.font.distinct};
	font-size: 1.8rem;
	margin-right: 1rem;
`;

export const Close = styled(Icon)`
	position: absolute;
	top: 0rem;
	right: -1rem;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.silver};
	cursor: pointer;
`;

export const TagBody = styled.div`
	height: 3rem;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	padding-right: 0.8rem;
	padding-left: 1.4rem;
	margin-top: 0.8rem;
	margin-right: 0.6rem;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 4px;
	${spaceX(6)};
	color: ${({ theme }) => theme.white};
	font-size: 1rem;
	font-weight: ${({ theme }) => theme.normal};
`;

export const StyledClose = styled(Icon)`
	font-size: 1rem;
	margin-left: 0.6rem;
	font-weight: ${({ theme }) => theme.font.bold};
	cursor: pointer;
	&:hover {
		color: ${({ theme }) => theme.silver};
	}
`;
